<template>
  <div class="box">
    <v-card class="pa-2 rounded-lg" outlined width="100%">
      <h1 style="padding-right: 10px">
        <v-icon class="pa-2" color="blue">mdi-information-outline</v-icon>
        دکمه‌های راهنما
      </h1>

      <v-container fluid class="filter-sort pb-0">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" md="7" sm="6" class="px-2">
            <v-select
              v-model="selectedService"
              :items="services"
              item-text="name"
              item-value="id"
              label="سرویس"
              class="rounded-lg v-input--dense ma-0 pa-0"
              dense
              outlined
              no-data-text="هیچ گزینه‌ای موجود نیست"
              loading-text="در حال بارگذاری سرویس‌ها..."
              @change="initData"
              :loading="serviceLoading"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="px-2">
            <v-btn
              class="btn-upload btn pa-0"
              @click="exportCsv"
              :loading="Csvloading"
              dense
              depressed
              :disabled="filteredButtonsHelpInfo.length === 0"
            >
              <v-icon>mdi-download</v-icon>
              دریافت
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="px-2"> </v-col>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col cols="12" sm="2" md="2" class="px-2">
            <v-select
              v-model="itemsPerPage"
              :items="[10, 25, 50, 100, 300, 500, 700, 1000, 2500, 5000]"
              class="rounded-lg v-input--dense ma-0 pa-0"
              label="تعداد"
              dense
              outlined
              no-data-text="هیچ گزینه‌ای موجود نیست"
              loading-text="در حال بارگذاری گزینه‌ها..."
              @change="currentPage = 1"
            ></v-select>
          </v-col>
          <v-col
            :cols="!!ButtonsHelpInfo?.length ? 9 : 10"
            :sm="!!ButtonsHelpInfo?.length ? 9 : 10"
            :md="!!ButtonsHelpInfo?.length ? 9 : 10"
            class="px-2"
          >
            <v-card class="pa-0 ma-0">
              <v-card-text class="pa-0 ma-0">
                <div class="coversearch">
                  <v-text-field
                    v-model="searchQuery"
                    label="جستجو"
                    outlined
                    class="rounded-lg v-input--dense mx-2 pa-0 mt-0 md-0"
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    dense
                  ></v-text-field>
                  <v-btn
                    class="btn-upload px-2 mx-2 mt-0 md-0"
                    @click="AdvSearch = !AdvSearch"
                    dense
                    depressed
                  >
                    <v-icon>{{
                      AdvSearch === true ? "mdi-magnify" : "mdi-filter-variant"
                    }}</v-icon>
                    <span>{{
                      AdvSearch === false ? " فیلتر پیشرفته" : "جستجو"
                    }}</span>
                  </v-btn>
                </div>

                <v-chip-group
                  v-model="activeFilters"
                  multiple
                  column
                  v-if="AdvSearch"
                >
                  <v-chip
                    v-for="(filter, index) in itemsFilter"
                    :key="index"
                    outlined
                    filter
                    :value="valueFilter[index]"
                    color="info"
                    >{{ filter }}</v-chip
                  >
                </v-chip-group>
                <v-chip-group
                  v-model="selectedCategories"
                  multiple
                  column
                  v-if="AdvSearch && selectedCategories.length > 0"
                  active-class="primart-text"
                >
                  <v-chip
                    outlined
                    filter
                    v-for="category in selectedCategories"
                    :key="category"
                    :value="category"
                    color="accent"
                  >
                    {{ category }}
                  </v-chip>
                </v-chip-group>
                <v-btn
                  v-if="AdvSearch && selectedCategories.length > 0"
                  @click="clearCategoryFilter"
                  small
                  outlined
                  color="red"
                  class="mt-2"
                  >پاک کردن فیلتر‌های دسته‌بندی</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            v-if="!!ButtonsHelpInfo?.length"
            :cols="!!ButtonsHelpInfo?.length ? 1 : 0"
            :md="!!ButtonsHelpInfo?.length ? 1 : 0"
            :sm="!!ButtonsHelpInfo?.length ? 1 : 0"
          >
            <v-badge
              dot
              right
              overlap
              :content="selectedCategories.length || 0"
              :value="selectedCategories.length > 0"
              color="green"
            >
              <v-btn
                icon
                dense
                @click="showCategoryFilter"
                title="فیلتر دسته‌بندی"
                ><v-icon>mdi-filter</v-icon></v-btn
              >
            </v-badge>
          </v-col>
        </v-row>
      </v-container>

      <v-container fluid class="pt-0">
        <v-alert
          v-if="activeFilters.length > 0 || selectedCategories.length > 0"
          type="info"
          dense
        >
          فیلترها فقط روی صفحه فعلی اعمال می‌شوند. برای دیدن همه نتایج، به صفحات
          دیگر بروید.
        </v-alert>
        <v-data-table
          :headers="headers"
          dense
          :items="filteredButtonsHelpInfo"
          :search="searchQuery"
          hide-default-footer
          class="elevation-1 pt-0 tight-rows"
          :loading="loading"
          loading-text="در حال دریافت اطلاعات..."
          no-data-text="هیچ اطلاعاتی برای نمایش وجود ندارد"
          :server-items-length="total"
          :options.sync="paginationOptions"
        >
          <template slot="item.index" slot-scope="{ index }">
            {{ index + 1 + (currentPage - 1) * itemsPerPage }}
          </template>
          <template slot="item.name" slot-scope="{ item }">
            <span class="link ellipsis d-inline-block text-truncate">
              {{ item.name }}
            </span>
          </template>
          <template slot="item.title" slot-scope="{ item }">
            <span class="link ellipsis d-inline-block text-truncate">
              {{ item.title }}
            </span>
          </template>
          <template slot="item.text" slot-scope="{ item }">
            <span class="link ellipsis d-inline-block text-truncate">
              {{ item.text }}
            </span>
          </template>
          <template slot="item.category" slot-scope="{ item }">
            <span class="link ellipsis d-inline-block text-truncate">
              {{ item.category }}
            </span>
          </template>
          <template slot="item.audio" slot-scope="{ item }">
            <div v-if="item.audio" class="audio-container">
              <v-btn
                icon
                small
                color="blue"
                @click="toggleAudio(item.audio, item.id)"
                :title="getFileName(item.audio)"
              >
                <v-icon color="blue" small>{{
                  isPlaying(item.id) ? "mdi-pause" : "mdi-play"
                }}</v-icon>
              </v-btn>
            </div>
            <span v-else>ندارد</span>
          </template>
          <template slot="item.media" slot-scope="{ item }">
            <div v-if="hasMedia(item)" class="media-container">
              <v-avatar
                size="36"
                v-if="item.images && item.images.length > 0"
                @click="showMediaSlider(item)"
              >
                <img
                  :src="item.images[0].url"
                  :alt="item.images[0].name || 'تصویر'"
                  class="thumbnail"
                />
              </v-avatar>
              <v-btn
                v-else-if="item.videos && item.videos.length > 0"
                icon
                small
                @click="showMediaSlider(item)"
              >
                <v-icon small color="blue">mdi-video</v-icon>
              </v-btn>
            </div>
            <span v-else>ندارد</span>
          </template>
          <template slot="item.actions" slot-scope="{ item }">
            <Buttons :data="item" :meta="meta"></Buttons>
          </template>
          <template slot="no-data">
            <div class="text-center pa-4">
              <v-icon class="text-h1 mt-15 mb-15"
                >mdi-information-outline</v-icon
              >
              <p>
                سرویسی را انتخاب کنید تا دکمه‌های راهنمای آن سرویس را مشاهده
                کنید
              </p>
            </div>
          </template>
        </v-data-table>
      </v-container>

      <v-divider></v-divider>
      <div class="w-100 text-center d-flex align-start py-2 px-6 flex-wrap">
        <div class="d-flex align-center" style="max-width: 200px">
          <span class="text-no-wrap me-2">برو به صفحه:</span>
          <v-text-field
            v-model.number="gotoPage"
            dense
            outlined
            type="number"
            :max="maxPage"
            :messages="`صفحه ${currentPage} از ${maxPage}`"
            :min="1"
            @input="changePage"
          ></v-text-field>
        </div>
        <v-spacer></v-spacer>
        <v-pagination v-model="currentPage" :length="maxPage"></v-pagination>
      </div>

      <!-- پاپ‌آپ اسلایدر مدیا -->
      <custom-popup
        v-model="mediaSliderDialog"
        :cons="{ title: 'نمایش مدیا' }"
        max-width="800"
        hide-confirm
        scrollable
      >
        <template v-slot:extension>
          <v-tabs
            class="popup-tuts"
            v-if="selectedMediaItem"
            v-model="activeMediaTab"
            align-with-title
            grow
            background-color="transparent"
            dark
            color="primary"
            show-arrows
          >
            <v-tabs-slider />
            <v-tab
              v-if="
                selectedMediaItem.images && selectedMediaItem.images.length > 0
              "
              key="images"
            >
              <v-icon left>mdi-image</v-icon>
              عکس‌های راهنما
            </v-tab>
            <v-tab
              v-if="
                selectedMediaItem.videos && selectedMediaItem.videos.length > 0
              "
              key="videos"
            >
              <v-icon left>mdi-video</v-icon>
              ویدیوهای راهنما
            </v-tab>
          </v-tabs>
        </template>

        <v-tabs-items v-model="activeMediaTab">
          <!-- تب عکس‌ها -->
          <v-tab-item
            v-if="
              selectedMediaItem &&
              selectedMediaItem.images &&
              selectedMediaItem.images.length > 0
            "
          >
            <v-card flat class="pa-4">
              <v-carousel
                height="400"
                show-arrows-on-hover
                class="media-carousel"
              >
                <v-carousel-item
                  v-for="(image, index) in selectedMediaItem.images"
                  :key="'image-' + index"
                >
                  <img
                    :src="image.url"
                    :alt="image.name || 'تصویر'"
                    style="
                      width: 100%;
                      max-height: 400px;
                      object-fit: contain;
                      border-radius: 10px;
                    "
                  />
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-tab-item>
          <!-- تب ویدیوها -->
          <v-tab-item
            v-if="
              selectedMediaItem &&
              selectedMediaItem.videos &&
              selectedMediaItem.videos.length > 0
            "
          >
            <v-card flat class="pa-4">
              <v-carousel
                height="450"
                show-arrows-on-hover
                class="media-carousel video-carousel"
              >
                <v-carousel-item
                  v-for="(video, index) in selectedMediaItem.videos"
                  :key="'video-' + index"
                >
                  <video
                    ref="sliderVideo"
                    controls
                    style="
                      width: 100%;
                      max-height: 400px;
                      border-radius: 10px;
                      background-color: black;
                    "
                    loading="lazy"
                    @error="handleVideoError"
                  >
                    <source :src="video.file_link" type="video/mp4" />
                    مرورگر شما از ویدیو پشتیبانی نمی‌کند.
                  </video>
                  <v-card-text
                    v-if="videoError"
                    class="text-center"
                    style="color: red"
                  >
                    خطا در بارگذاری ویدئو (ممکن است دسترسی محدود باشد).
                  </v-card-text>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </custom-popup>

      <!-- پاپ‌آپ فیلتر دسته‌بندی -->
      <custom-popup
        max-width="400"
        v-model="filterDialog"
        :cons="cons"
        :loading.sync="filterloading"
        hide-confirm
        transition="dialog-bottom-transition"
        scrollable
      >
        <v-col cols="12" md="12">
          <v-chip-group v-model="selectedCategories" multiple row show-arrows>
            <v-chip
              v-for="category in categoryFilter"
              :key="category"
              :value="category"
              filter
              outlined
              color="accent"
            >
              {{ category }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </custom-popup>

      <!-- پاپ‌آپ جزئیات -->
      <popup-content
        :dialog.sync="detailDialog"
        :cons="{ title: 'جزئیات دکمه راهنما' }"
        :loading.sync="detailLoading"
        :item="selectedItem"
        :itemtitle="detailItemTitle"
      />
    </v-card>
  </div>
</template>

<script>
import AddNewUserGuide from "@/view/content/addNewUserGuide.vue";
import PopupContent from "./PopupContent.vue";
import Buttons from "./buttons.vue";
import {
  getContentType,
  GetServices,
  GetCategories,
  DeleteButtonInfo,
  GetAllGuideContent,
} from "./GuideContent_axios.js";
import {
  convertTableToCsv,
  downloadCvsFile,
} from "@/assets/js/FunctionLink.js";
import _ from "lodash";

export default {
  name: "userGuideStore3",
  components: { PopupContent, Buttons, AddNewUserGuide },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      serviceLoading: false,
      selectedCategories: [],
      categoryFilter: [],
      activeFilters: [],
      filterDialog: false,
      filterloading: false,
      cons: { title: "فیلتر دسته‌بندی‌" },
      clearFilter: 1,
      AdvSearch: false,
      enableFilter: true,
      itemsFilter: ["با عکس", "با ویدئو", "با فایل صوتی"],
      valueFilter: ["hasImage", "hasVideo", "hasAudio"],
      audioPlayers: {},
      playingStates: {},
      detailDialog: false,
      detailLoading: false,
      selectedItem: {},
      Categories: [],
      services: [],
      ButtonsHelpInfo: [],
      selectedId: null,
      loading: false,
      Csvloading: false,
      searchQuery: "",
      currentPage: 1,
      itemsPerPage: 10,
      gotoPage: 1,
      selectedService: null,
      mediaSliderDialog: false,
      selectedMediaItem: null,
      videoError: false,
      activeMediaTab: 0,
      total: 0,
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "ردیف", value: "index", sortable: false, align: "center" },
        { text: "نام", value: "name", align: "right" },
        { text: "عنوان", value: "title", align: "right" },
        { text: "توضیحات", value: "text", align: "right" },
        { text: "دسته‌بندی", value: "category", align: "right" },
        { text: "فایل صوتی", value: "audio", align: "center" },
        { text: "فیلم/تصویر", value: "media", align: "center" },
        { text: "مدیریت", value: "actions", sortable: false, align: "center" },
      ],
      meta: {
        buttons: [
          {
            name: "edit",
            label: "ویرایش",
            icon: "pencil",
            class: "btn-edit border-2 rounded-pill",
            action: this.updateHelpinfo,
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash-can",
            class: "btn-delete rounded-pill",
            action: this.deleteHelpinfo,
          },
          {
            name: "detail",
            label: "نمایش",
            icon: "information",
            class: "btn-show rounded-pill",
            action: this.showDetail,
          },
        ],
      },
    };
  },
  computed: {
    detailItemTitle() {
      const baseTitles = [
        { title: "جزئیات", icon: "information-outline", color: "blue" },
      ];
      if (this.selectedItem.images && this.selectedItem.images.length > 2) {
        baseTitles.push({
          title: "عکس‌های راهنما",
          icon: "image",
          color: "green",
        });
      }
      if (this.selectedItem.videos && this.selectedItem.videos.length > 2) {
        baseTitles.push({
          title: "ویدئوهای راهنما",
          icon: "video",
          color: "green",
        });
      }
      if (this.selectedItem.qa && this.selectedItem.qa.length > 0) {
        baseTitles.push({
          title: "سوالات متداول",
          icon: "comment-question-outline",
          color: "green",
        });
      }
      return baseTitles;
    },
    filteredButtonsHelpInfo() {
      let result = [...this.ButtonsHelpInfo];

      if (this.activeFilters.length > 0) {
        result = result.filter((item) => {
          return this.activeFilters.some((filter) => {
            if (filter === "hasImage") {
              return item.images && item.images.length > 0;
            }
            if (filter === "hasVideo") {
              return item.videos && item.videos.length > 0;
            }
            if (filter === "hasAudio") {
              return item.audio;
            }
            return false;
          });
        });
      }

      if (this.selectedCategories.length > 0) {
        result = result.filter((item) => {
          return this.selectedCategories.includes(item.category);
        });
      }

      result.sort((a, b) => {
        const DateA = new Date(a.updated_at || a.created_at);
        const DateB = new Date(b.updated_at || b.created_at);
        return DateB - DateA;
      });

      return result;
    },
    maxPage() {
      return Math.ceil(this.total / this.itemsPerPage) || 1;
    },
  },
  created() {
    this.init_data();
    this.restoreStateFromRoute();
  },
  beforeDestroy() {
    Object.values(this.audioPlayers).forEach((player) => {
      if (player) {
        player.pause();
        player.src = "";
      }
    });
  },
  watch: {
    selectedService(newVal) {
      if (newVal) {
        if (newVal !== null) this.fetchCategoriesAndData();
      } else {
        this.ButtonsHelpInfo = [];
        this.Categories = [];
        this.categoryFilter = [];
      }
    },
    searchQuery: _.debounce(function () {
      this.currentPage = 1;
      this.gotoPage = 1;
      this.initData();
    }, 500),
    itemsPerPage() {
      this.currentPage = 1;
      this.gotoPage = 1;
      this.initData();
    },
    currentPage(newVal) {
      this.gotoPage = newVal;
      this.initData();
    },
    paginationOptions: {
      handler(newVal) {
        this.currentPage = newVal.page;
        this.itemsPerPage = newVal.itemsPerPage;
        this.initData();
      },
      deep: true,
    },
    mediaSliderDialog(newVal) {
      if (!newVal) {
        this.selectedMediaItem = null;
        this.videoError = false;
        this.activeMediaTab = 0;
        if (this.$refs.sliderVideo) {
          (Array.isArray(this.$refs.sliderVideo)
            ? this.$refs.sliderVideo
            : [this.$refs.sliderVideo]
          ).forEach((video) => {
            if (!video.paused) video.pause();
          });
        }
      }
    },
  },
  methods: {
    hasMedia(item) {
      return (
        (item.images && item.images.length > 0) ||
        (item.videos && item.videos.length > 0)
      );
    },
    showMediaSlider(item) {
      this.selectedMediaItem = item;
      this.mediaSliderDialog = true;
      this.activeMediaTab =
        item.images && item.images.length > 0
          ? 0
          : item.videos && item.videos.length > 0
          ? 1
          : 0;
    },
    handleVideoError() {
      this.videoError = true;
    },
    restoreStateFromRoute() {
      const returnState = this.$route.params.returnState;
      if (returnState) {
        this.currentPage = returnState.currentPage || 1;
        this.itemsPerPage = returnState.itemsPerPage || 10;
        this.searchQuery = returnState.searchQuery || "";
        this.selectedCategories = returnState.selectedCategories || [];
        this.activeFilters = returnState.activeFilters || [];
        this.gotoPage = this.currentPage;
      }
    },
    showCategoryFilter() {
      this.filterloading = true;
      this.filterDialog = true;
      this.clearFilter =
        this.selectedCategories.length > 0 ? this.selectedCategories.length : 0;
      this.filterloading = false;
    },
    clearCategoryFilter() {
      this.selectedCategories = [];
      this.clearFilter = 0;
    },
    async showDetail(itemElement) {
      this.detailLoading = true;
      this.selectedItem = {
        title: itemElement.title || "",
        text: itemElement.text || "",
        images: itemElement.images || [],
        videos: itemElement.videos || [],
        qa: itemElement.qa || [],
        audio: itemElement.audio.length > 0 ? itemElement.audio[0] : null,
      };
      this.detailLoading = false;
      this.detailDialog = true;
    },
    async init_data() {
      this.loading = true;
      this.serviceLoading = true;
      try {
        this.services = await GetServices();
        let id = this.$route.params.id
          ? Number(this.$route.params.id)
          : this.id !== null
          ? this.id
          : null;
        this.selectedService = id
          ? Number(id)
          : this.id !== null
          ? this.id
          : null;
        if (this.selectedService) {
          await this.fetchCategoriesAndData();
        }
      } catch (error) {
        console.error("خطا در دریافت اطلاعات اولیه:", error);
      } finally {
        this.loading = false;
        this.serviceLoading = false;
      }
    },
    async fetchCategoriesAndData() {
      try {
        this.loading = true;

        this.Categories = await GetCategories(this.selectedService);
        this.categoryFilter = this.Categories.map((cat) => cat.name);
        await this.initData();
      } catch (error) {
        console.error("خطا در دریافت دسته‌بندی‌ها:", error);
        this.Categories = [];
        this.categoryFilter = [];
      } finally {
        this.loading = false;
      }
    },
    initData() {
      if (!this.selectedService) {
        console.log(this.selectedService, "here4");
        this.ButtonsHelpInfo = [];
        this.total = 0;
        return;
      }
      this.loading = true;
      console.log(this.selectedService, "here5");
      GetAllGuideContent(
        this.selectedService,
        this.searchQuery,
        null,
        this.currentPage,
        this.itemsPerPage
      )
        .then((guideContent) => {
          this.total = guideContent.total;
          this.ButtonsHelpInfo = guideContent.data.map((itemElement) => {
            const category = this.Categories.find(
              (p) => itemElement.category_id === p.id
            );
            console.log(guideContent, "guideContent");
            let item = {
              id: itemElement.id,
              name: itemElement.name || "",
              title: itemElement.title || "",
              text: itemElement.text || "",
              images: itemElement.extras?.images[0]?.images || [],
              videos: itemElement.extras?.videos[0]?.images || [],
              audio:
                itemElement.extras?.audio.length > 0
                  ? itemElement.extras?.audio[0]
                  : null,
              qa: itemElement.extras?.qa || [],
              category: category ? category.name : "بدون دسته‌بندی",
              created_at: itemElement.created_at,
              updated_at: itemElement.updated_at,
            };
            console.log(item, "guideContent-item11");

            if (
              itemElement.link &&
              itemElement.link !== null &&
              itemElement.link !== ""
            ) {
              let contentType;
              try {
                contentType = getContentType(itemElement.link);
              } catch (err) {
                console.error("خطا در دریافت نوع محتوا:", err);
                contentType = null;
              }

              if (contentType?.startsWith("video/")) {
                item.videos = [
                  ...item.videos,
                  { file_link: itemElement.link, name: "ویدیو از لینک" },
                ];
              } else if (contentType?.startsWith("image/")) {
                item.images = [
                  ...item.images,
                  { url: itemElement.link, name: "تصویر از لینک" },
                ];
              } else if (contentType?.startsWith("audio/")) {
                item.audio = item.audio || itemElement.link;
              } else {
                console.warn("نوع فایل ناشناخته است:", contentType);
              }
            }
            console.log(item, "guideContent-item");

            return item;
          });
        })
        .catch((error) => {
          this.$toast.error(
            error.response?.data?.message || "خطا در دریافت داده‌ها"
          );
          console.error("خطا در دریافت داده‌ها:", error);
          this.ButtonsHelpInfo = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleAudio(audioUrl, itemId) {
      itemId = String(itemId);

      if (this.$refs.sliderVideo) {
        (Array.isArray(this.$refs.sliderVideo)
          ? this.$refs.sliderVideo
          : [this.$refs.sliderVideo]
        ).forEach((video) => {
          if (!video.paused) video.pause();
        });
      }

      Object.entries(this.audioPlayers).forEach(([id, player]) => {
        if (id !== itemId && player && !player.paused) {
          player.pause();
          this.$set(this.playingStates, id, false);
        }
      });

      if (this.audioPlayers[itemId]) {
        const player = this.audioPlayers[itemId];
        if (player.paused) {
          try {
            player.play();
            this.$set(this.playingStates, itemId, true);
          } catch (error) {
            this.$toast.error("نمی‌تونم فایل صوتی رو پخش کنم");
          }
        } else {
          try {
            player.pause();
            this.$set(this.playingStates, itemId, false);
          } catch (error) {
            console.error("خطا در توقف:", error);
            this.$toast.error("نمی‌تونم فایل صوتی رو متوقف کنم");
          }
        }
      } else {
        const newPlayer = new Audio(audioUrl);
        this.$set(this.audioPlayers, itemId, newPlayer);
        this.$set(this.playingStates, itemId, true);
        try {
          newPlayer.play();
        } catch (error) {
          this.$toast.error("خطا در پخش فایل صوتی");
          this.$set(this.playingStates, itemId, false);
        }
        newPlayer.onended = () => {
          this.$set(this.playingStates, itemId, false);
        };
        newPlayer.onerror = () => {
          this.$toast.error("خطا در پخش فایل صوتی");
          this.$set(this.playingStates, itemId, false);
        };
      }
    },
    isPlaying(itemId) {
      return this.playingStates[String(itemId)] || false;
    },
    getFileName(url) {
      if (typeof url === "string" && url) {
        return url.split("/").pop();
      }
      return "";
    },
    exportCsv() {
      this.Csvloading = true;
      const csvContent = convertTableToCsv(
        this.headers,
        this.filteredButtonsHelpInfo
      );
      downloadCvsFile(csvContent, "help_info_data.csv");
      this.Csvloading = false;
    },
    gotoCreatehelpinfo() {
      this.$router.push(`/admin/user-guide`);
    },
    async deleteHelpinfo(item) {
      this.selectedId = item.id;
      if (
        await this.$modal.yesNo(
          "آیا مطمئن هستید که می‌خواهید این مورد حذف شود؟"
        )
      ) {
        await this.deletesl();
      }
    },
    async deletesl() {
      if (!this.selectedId) return;
      try {
        this.loading = true;
        await DeleteButtonInfo(this.selectedId);
        this.$toast.success("با موفقیت حذف شد!");
        await this.initData();
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "خطا در حذف آموزش!");
        console.error("خطا در حذف داده:", error);
      } finally {
        this.selectedId = null;
        this.loading = false;
      }
    },
    updateHelpinfo(item) {
      if (item?.id) {
        this.$router.push(`/admin/user-guide/${item.id}`);
      }
    },
    changePage() {
      const page = Number(this.gotoPage);
      if (page > 0 && page <= this.maxPage) {
        this.currentPage = page;
        this.initData();
        this.$forceUpdate();
      }
      this.gotoPage = this.currentPage;
    },
  },
};
</script>

<style scoped>
.v-data-table >>> tbody tr:nth-child(odd) {
  background-color: #ebedf3;
}
.v-data-table >>> .v-data-table-header-mobile__wrapper {
  justify-content: flex-end;
}
.bottom-sticky {
  position: sticky;
  bottom: 0;
}
.box {
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 1px;
  width: 100%;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
  word-break: keep-all;
}
.audio-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.media-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.thumbnail {
  cursor: pointer;
  object-fit: cover;
}
@media (max-width: 780px) {
  .ellipsis {
    max-width: 50px;
  }
}
.btn {
  width: 100%;
}
.content {
  max-width: 100%;
  width: 100%;
  height: auto;
}
.tight-rows tbody tr td {
  padding-right: 8px !important;
  padding-left: 8px !important;
}
.coversearch {
  width: 100%;
  display: flex;
  flex-direction: row;
}

/* استایل‌های سفارشی برای کاروسل ویدیو */
.media-carousel.video-carousel {
  position: relative;
}
.media-carousel.video-carousel .v-carousel__controls {
  background: black;
  height: 50px;
  position: relative;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.media-carousel.video-carousel .v-carousel__controls__item {
  color: white !important;
  opacity: 0.6;
}
.media-carousel.video-carousel .v-carousel__controls__item.v-item--active {
  opacity: 1;
}
.audio-container + span {
  color: #757575;
  font-style: italic;
}
</style>
